import TermsParagraph from "@/components/atoms/TermsParagraph";
import { FooterDataType } from "@/components/organisms/Footer";
import { PageTemplate } from "@/components/organisms/PageTemplate";
import { footerData_en, footerData_us } from "@/shared/data/footer.data";
import { footerData_kr } from "@/shared/data/footer.data.kr";
import { NavbarDataType, navbarData_en, navbarData_us } from "@/shared/data/navbar.data";
import { navbarData_kr } from "@/shared/data/navbar.data.kr";
import { GetStaticProps, InferGetStaticPropsType } from "next";
import Head from "next/head";
import Link from "next/link";

type RefundPolicyProps = {};

export const getStaticProps: GetStaticProps<{
  navbarData: NavbarDataType;
  footerData: FooterDataType;
}> = async (context) => {
  const navbarData = {
    en: navbarData_en,
    us: navbarData_us,
    kr: navbarData_kr,
    in: navbarData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  const footerData = {
    en: footerData_en,
    us: footerData_us,
    kr: footerData_kr,
    in: footerData_en,
  }[(context.locale as "en" | "kr" | "us" | "in") ?? "en"];

  return {
    props: {
      navbarData,
      footerData,
    },
  };
};
export default function RefundPolicyPage({
  navbarData,
  footerData,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <PageTemplate navbarData={navbarData} footerData={footerData}>
      <div className="mb-20">
        <Head>
          <title>Refund Policy - Graphy</title>
          <meta name="description" content="Graphy Refund Policy" />
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
        </Head>
        <div className="link-dash flex w-full flex-col items-center justify-center px-6">
          <div className="WordSection1 max-w-3xl">
            <h1 className="mx-auto mt-24 text-center text-5xl font-extrabold text-black">
              Graphy Refund Policy
            </h1>
            <h2 className="mb-10 pt-6 text-center text-xl uppercase tracking-ultrawide text-black">
              Last Updated: June 20, 2022
            </h2>
          </div>
          <div className="max-w-4xl">
            <TermsParagraph>
              You may cancel your Subscription{" "}
              <i>(as defined in our Terms of Service)</i> by either writing to
              us at{" "}
              <a href="mailto:care@graphy.com" className="text-dashDark">
                care@graphy.com
              </a>{" "}
              or through your account on the Platform. However, there shall be
              no refund of the Fee (including the onboarding fee as stated in
              the <Link href="/pricing">Pricing Page</Link>) already paid by you
              to Graphy.
            </TermsParagraph>

            <TermsParagraph>
              On the other hand, if you have subscribed to any of our
              Subscriptions that require you to pay a recurring flat Fee (as
              stated in the <Link href="/pricing">Pricing Page</Link>
              ), then you may be entitled to a full refund (subject to
              applicable taxes) of the recurring flat Fee only, provided that
              your cancellation request is made within 7 (seven) days from the
              date of purchase of your Subscription Plan, either via email or
              through your account as stated above <b>(“Refund Period”)</b>.
              However, please note that any cancellation requests received post
              the Refund Period shall not entitle you for a refund of the
              recurring flat Fee.
            </TermsParagraph>

            <TermsParagraph>
              Please carefully read our Terms of Service, the Refund Policy
              along with any other documents made available on the Platform
              before purchasing any of our Subscription Plans.
            </TermsParagraph>

            <TermsParagraph>
              When you cancel your Subscription Plan, Graphy may disable access
              to features available only to Creators who have purchased/renewed
              Subscription, while your account may continue to exist on the
              Platform.
            </TermsParagraph>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
}
